import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function ComingSoon() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/subscribe", { email, source: "coming_soon" });
      try { localStorage.setItem("aperture_captured", "1"); } catch {}
      setDone(true); toast.success("You're on the list.");
    }
    catch { toast.error("Something went wrong."); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: "#0A2540" }} data-testid="coming-soon-page">
      <img src="https://images.unsplash.com/photo-1691943703496-977ff624d182?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <div className="mb-2">
          <Logo size={110} color="#F7F5F0" />
        </div>
        <div className="eyebrow text-white/80" style={{ color: "#C4A265" }}>Aperture Enterprises</div>
        <h1 className="mt-6 font-serif text-white text-5xl md:text-7xl tracking-tight leading-[1.05] max-w-3xl">Opening doors, soon.</h1>
        <p className="mt-8 text-white/70 max-w-lg leading-relaxed">
          A private catalog of playbooks for creative real estate and housing solutions. Add your name to the list — we'll send a free sample on launch day.
        </p>
        {done ? (
          <div className="mt-10 text-gold font-serif text-2xl" data-testid="cs-done">You're on the list.</div>
        ) : (
          <form onSubmit={submit} className="mt-10 flex gap-3 max-w-md w-full" data-testid="cs-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" data-testid="cs-email"
              className="flex-1 px-5 py-4 bg-white/10 border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-gold rounded-sm" />
            <button disabled={busy} data-testid="cs-submit" className="px-8 py-4 bg-gold text-navy text-xs uppercase tracking-[0.24em] font-medium hover:bg-white transition-colors duration-300 rounded-sm">{busy ? "…" : "Notify me"}</button>
          </form>
        )}
        <div className="mt-24 text-white/40 text-xs uppercase tracking-widest">© Aperture Enterprises, LLC</div>
      </div>
    </div>
  );
}
